import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from './MetaPixel';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-127">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-128">
        <img src="https://cdn.magicpatterns.com/uploads/hKBMz5u7RmanGTADrbUsff/ChatGPT_Image_18_may_2026,_10_16_28.png" alt="Freddy Pimentel" className="w-full h-full object-cover object-center" data-id="element-129" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/80 to-transparent" data-id="element-130"></div>
        <div className="absolute inset-0 bg-ink/40" data-id="element-131"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 pt-20 pb-12" data-id="element-132">
        <div className="max-w-3xl" data-id="element-133">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-134">
            <span className="text-gold tracking-[0.2em] text-xs md:text-sm font-semibold uppercase mb-6 block" data-id="element-135">
              Mentoría Estratégica 1 a 1
            </span>
          </motion.div>

          <motion.h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-ivory-bright leading-[1.1] mb-8" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-136">
            No extrañas a esa persona… <br data-id="element-137" />
            <span className="font-script text-5xl md:text-7xl lg:text-8xl text-gold font-normal block mt-2" data-id="element-138">
              extrañas la paz que perdiste contigo
            </span>
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.4,
          ease: [0.16, 1, 0.3, 1]
        }} className="space-y-6 text-lg md:text-xl text-ivory/90 max-w-2xl font-light" data-id="element-139">
            <p data-id="element-140">
              Mentoría Estratégica 1 a 1 para personas que desean sanar
              emocionalmente, recuperar claridad mental, fortalecer sus
              relaciones y volver a conectar con su propósito.
            </p>
            <p className="text-muted text-base md:text-lg" data-id="element-141">
              Muchas personas siguen funcionando por fuera… mientras por dentro
              sienten que algo se rompió. Y con el tiempo: la ansiedad
              emocional, el vacío interior y el agotamiento mental comienzan a
              afectar todas las áreas de la vida.
            </p>
            <p className="font-serif text-2xl text-ivory-bright italic" data-id="element-142">
              Hoy quiero ayudarte a reconstruirte desde adentro.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-12" data-id="element-143">
            <a href="https://wa.me/5491145263003" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366] text-white hover:bg-[#1DA851] transition-all duration-300 font-medium tracking-wide group shadow-lg shadow-[#25D366]/20" data-id="element-144">
              <MessageCircle className="w-5 h-5 group-hover:scale-110 transition-transform" data-id="element-145" />
              QUIERO HABLAR CON FREDDY
            </a>
            <p className="mt-4 text-sm text-muted flex items-center gap-2" data-id="element-146">
              <span className="text-gold" data-id="element-147">⚠️</span> Atención personalizada •
              Cupos limitados según disponibilidad.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}